import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { authorLabel } from '@/lib/structuredData';

export default function BlogCard({ post, featured = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <Link
        to={`/blog/${post.slug}`}
        className={`group block rounded-2xl border border-border/50 bg-card overflow-hidden hover:border-primary/40 transition-all duration-300 h-full ${featured ? 'md:flex' : ''}`}
      >
        <div className={`overflow-hidden ${featured ? 'md:w-1/2' : ''}`}>
          <img
            src={post.cover_image}
            alt={post.title}
            loading="lazy"
            className={`w-full object-cover group-hover:scale-105 transition-transform duration-500 ${featured ? 'h-56 md:h-full' : 'h-48'}`}
          />
        </div>
        <div className={`p-6 flex flex-col ${featured ? 'md:w-1/2 justify-center' : ''}`}>
          <span className="text-[10px] font-inter font-bold tracking-[0.2em] uppercase text-primary mb-3">
            {post.category}
          </span>
          <h2 className={`font-inter font-bold text-foreground leading-snug mb-2 group-hover:text-primary transition-colors ${featured ? 'text-2xl md:text-3xl' : 'text-lg'}`}>
            {post.title}
          </h2>
          <p className="text-sm text-muted-foreground font-inter leading-relaxed mb-4 line-clamp-3">
            {post.excerpt}
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-muted-foreground font-inter mt-auto">
            <span>By {authorLabel(post)}</span>
            <span>{post.published_date ? new Date(post.published_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''}</span>
            <span className="flex items-center gap-1">
              <Clock className="w-3.5 h-3.5" />
              {post.reading_time || 5} min read
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}